export default {
  watch: {
    options: {
      handler () {
        this.init()
      },
      deep: true
    }
  }
}
